import  * as actions from '../actions/actionTypes';
import { IStatsTeamLastXState, IState } from '../store/state';

const statsTeamLastX = (state: IStatsTeamLastXState = {}, action: any) : IStatsTeamLastXState => {
	switch (action.type) {
		case actions.FETCH_STATS_TEAM_LAST_X_SUCCEEDED:
			return Object.assign({}, state, action.data);
		case actions.FETCHING_STATS_ABORTED:
		case actions.FETCH_STATS_TEAM_LAST_X_FAILED:
			//console.error(action.type, action.data);
			return Object.assign({}, state, action.data) ;
    default:
      return state;
  }
};

/*
    Returns an object containing all wins and losses for each teamId
*/
export const getLastMatchesWinsAndLossesByTeamIds = (state: IState, channel: number, homeOrAway: teamType) => {
  // If statsTeamLastX data exists
  try {
		if( !Object.keys(state.statsTeamLastX).length ) {
			return [];
		}

		// Map isHomeOrAway to integer 0,1 to get the index key
		let homeOrAwayIndex = homeOrAway === 'home' ? 0 : 1;

		// Prepare the data for the map()
		const data = state.statsTeamLastX[channel][homeOrAwayIndex].doc[0].data;	
		const matches = data.matches || [];
		const teamId = data.team._id;

		/*
			Map over the matches of the current home/away team and 
			return an array containing the results as string for the last 5 matches
		*/
		const allWinsAndLosses = matches.map((match: any) => {
			/* 
				In the map() it is possible that the current home/away team is inverted, because he played as home and away team in the past.
				We have to check again for the match in the map()
			*/
			let homeOrAway = match.teams.away.uid === teamId ? 'away' : 'home';
	
			return match.result.winner === homeOrAway ? 'won' : 'lost';
		});

		return allWinsAndLosses;
	
	} catch (error) {
		/*
		// If no data exists, return empty array.
		console.error('getLastMatchesWinsAndLossesByTeamIds: something went wrong :( ', error);
		*/
		return [];
	}
};

export default statsTeamLastX;
